/**
 * mwApp.devices module <br>
 * Work with devices: show/add/edit/remove
 *
 * @namespace mwApp/devices
 */

import AddDeviceCtrl from './addDevice.controller'
import DevicesCtrl from './devices.controller'
import devicesConfig from './devices.config'

export default
angular.module('mwApp.devices', [])
  .config(devicesConfig)
  .controller('DevicesCtrl', DevicesCtrl)
  .controller('AddDeviceCtrl', AddDeviceCtrl)
